import { render, staticRenderFns } from "./cate.vue?vue&type=template&id=9c5d6ab0&scoped=true"
import script from "./cate.vue?vue&type=script&lang=js"
export * from "./cate.vue?vue&type=script&lang=js"
import style0 from "./cate.vue?vue&type=style&index=0&id=9c5d6ab0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5d6ab0",
  null
  
)

export default component.exports